import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');
export const getPatchProcessing = createSelector(
  getPortalState,
  (state: any) => state.patchProcessing,
);
